const FORMAT_DECIMAL_ODDS_PATH = 'format-decimal-odds';
const FORMAT_ODDS_PATH = 'format-odds';
const GET_AMERICAN_ODDS_PATH = 'get-american-odds';
const GET_FRACTIONAL_ODDS_PATH = 'get-fractional-odds';
const GET_ODDS_TO_DECIMALS_PATH = 'get-odds-to-decimals';
const ODDS_UTILS_PATH = 'odds';

const getOddsUtilPath = (utilPath, skipRoot = false) => {
    return skipRoot ? utilPath : `/${ODDS_UTILS_PATH}/${utilPath}`;
};

export {
    FORMAT_DECIMAL_ODDS_PATH,
    FORMAT_ODDS_PATH,
    GET_AMERICAN_ODDS_PATH,
    GET_FRACTIONAL_ODDS_PATH,
    GET_ODDS_TO_DECIMALS_PATH,
    getOddsUtilPath,
};
